import { GetPatientInquiryListStatusEnum } from "../../../../../services";

/**
 * The status filter is carried in the URL so other screens can deep-link into
 * this list with a filter already applied — the scheduling pending-inquiry
 * badge opens `?status=PENDING`.
 */
export const PATIENT_INQUIRY_STATUS_PARAM = "status";

export const STATUS_FILTER_OPTIONS = [
  { value: GetPatientInquiryListStatusEnum.Pending, label: "Pending" },
  { value: GetPatientInquiryListStatusEnum.Confirmed, label: "Confirmed" },
  { value: GetPatientInquiryListStatusEnum.Rejected, label: "Rejected" },
];

export const SOURCE_FILTER_OPTIONS = [
  { value: "WEBSITE", label: "Website" },
  { value: "PORTAL", label: "Portal" },
];

export const PATIENT_TYPE_FILTER_OPTIONS = [
  { value: "NEW", label: "New" },
  { value: "EXISTING", label: "Existing" },
];

export const INQUIRY_SOURCE_WEBSITE = "WEBSITE";
export const INQUIRY_PATIENT_TYPE_EXISTING = "EXISTING";

// `isWidgetApproved` tells the backend whether the patient registration that
// came along with the website request should still be approved.
export const CANCEL_OPTIONS = [
  {
    isWidgetApproved: true,
    label: "Cancel Visit Only",
    description:
      "Only the appointment request is cancelled. The patient record is still created with an MRN and appears in the Patient List, so the patient can request a new appointment later.",
  },
  {
    isWidgetApproved: false,
    label: "Cancel Visit & Patient",
    description:
      "Both the appointment request and the patient registration are cancelled. No patient record, MRN or portal credentials are created and the patient can register again as new.",
  },
];

const STATUS_COLOR_MAP: Record<
  string,
  { color: string; bgColor: string; label: string }
> = {
  PENDING: { color: "#7A4E00", bgColor: "#FFF4CC", label: "Pending" },
  CONFIRMED: { color: "#1B5E20", bgColor: "#E8F5E9", label: "Confirmed" },
  REJECTED: { color: "#B71C1C", bgColor: "#FFEBEE", label: "Rejected" },
  BOOKING_PENDING: {
    color: "#0D47A1",
    bgColor: "#E3F2FD",
    label: "Booking Pending",
  },
};

export const getStatusUi = (status?: string | null) => {
  const key = (status ?? "").toUpperCase();
  return (
    STATUS_COLOR_MAP[key] ?? {
      color: "#4A4A4A",
      bgColor: "#F2F4F7",
      label: status || "-",
    }
  );
};
